import getUncompletedSections from './getUncompletedSections';
import {isDemandPreparing} from "./getDemandStatus";
import {DemandValidation} from "../constants/DemandValidation";

export default (demandValidation) => {
    if (!demandValidation || !isDemandPreparing()) return false;
    const uncompleted = getUncompletedSections(demandValidation);
    return uncompleted.length === 0 || (uncompleted.length === 1 && uncompleted[0] === DemandValidation.APPROVAL);
}
